// Indian formatting
export function formatINR(paise) {
  if (paise == null || isNaN(paise)) return "₹0";
  const rupees = Math.round(paise / 100);
  return "₹" + rupees.toLocaleString("en-IN");
}
export function formatINRSubtle(paise) {
  if (paise == null) return "—";
  return formatINR(paise);
}
// DD/MM/YYYY
export function formatDate(input) {
  if (!input) return "—";
  const d = typeof input === "string" ? new Date(input) : input;
  if (isNaN(d.getTime())) return "—";
  const dd = String(d.getDate()).padStart(2, "0");
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const yyyy = d.getFullYear();
  return `${dd}/${mm}/${yyyy}`;
}
export function daysBetween(a, b) {
  const ms = new Date(b).getTime() - new Date(a).getTime();
  return Math.ceil(ms / (1000 * 60 * 60 * 24));
}

// Wallet transaction types that represent commission (i.e. not brokerage,
// not a withdrawal). Kept as one source of truth so "Commission Earned"
// stats never silently go stale again when a new commission type is added
// on the backend.
export const COMMISSION_TX_TYPES = [
  "agreement_commission",
  "protection_fee_commission",
  "proof_service_commission",
  "monthly_milestone_bonus",
  "deal_milestone_bonus",
  "broker_recruit_bonus",
  // Legacy types from before the commission refactor — no longer created,
  // kept here so historical transactions still count toward the total.
  "commission_credit",
  "agent_referral",
];

// Split of COMMISSION_TX_TYPES into the two dashboard boxes: Incentives
// (monthly milestone bonus — locked until the cycle ends, see
// agent_wallets.locked_balance_paise) vs Commission (flat agreement fee,
// deposit-protection %, referral bonuses, brokerage — always withdrawable
// immediately). Every entry in COMMISSION_TX_TYPES plus "brokerage" belongs
// to exactly one of these two lists.
export const INCENTIVE_TX_TYPES = [
  "monthly_milestone_bonus",
  "deal_milestone_bonus", // legacy one-time predecessor of the same program
];

export const PURE_COMMISSION_TX_TYPES = [
  "agreement_commission",
  "protection_fee_commission",
  "proof_service_commission",
  "broker_recruit_bonus",
  "brokerage",
  "commission_credit",
  "agent_referral",
];

export function walletTxTypeLabel(type) {
  switch (type) {
    case "agreement_commission": return "Agreement fee commission";
    case "protection_fee_commission": return "Deposit protection commission";
    case "proof_service_commission": return "Dispute-resolution commission";
    case "monthly_milestone_bonus": return "Monthly milestone bonus";
    case "deal_milestone_bonus": return "5-deal milestone bonus";
    case "broker_recruit_bonus": return "Referral bonus";
    // Legacy types from before the commission refactor — no longer created,
    // but historical transactions of these types may still exist.
    case "commission_credit": return "Orello commission";
    case "agent_referral": return "Referral bonus";
    case "brokerage": return "Brokerage (dalali)";
    case "withdrawal": return "Withdrawal";
    case "withdrawal_debit": return "Withdrawal";
    default: return type;
  }
}
